import { sha256 } from 'js-sha256';

export async function CalculateSha256Hash(file: File): Promise<string> {
  const arrayBuffer = await (file as any).arrayBuffer();
  const digestSha256 = sha256(arrayBuffer);

  return digestSha256;
}
